var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.leftAddon
        ? _c("div", {
            ref: "stencilContainer",
            staticClass: "aside",
            attrs: { id: "stencil" },
          })
        : _vm._e(),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "el-select",
              {
                staticClass: "mr10",
                model: {
                  value: _vm.edgeRouter,
                  callback: function ($$v) {
                    _vm.edgeRouter = $$v
                  },
                  expression: "edgeRouter",
                },
              },
              _vm._l(_vm.options, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _vm.movable
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("refresh")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("resetText")))]
                )
              : _vm._e(),
            _vm.movable
              ? _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                  [_vm._v(_vm._s(_vm.$t("saveText")))]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", {
          ref: "container",
          staticClass: "container",
          attrs: { id: "container" },
        }),
      ]),
      _c("storeForm", {
        ref: "storeForm",
        on: { handleConfirm: _vm.handleConfirm, close: _vm.storeFormClose },
      }),
      _c("updataForm", {
        ref: "updataForm",
        on: {
          handleConfirm: function ($event) {
            return _vm.$emit("refresh")
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("AllocationRatioText"),
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            _vm._l(_vm.form.ratioList, function (item, index) {
              return _c(
                "el-form-item",
                {
                  key: item.index,
                  attrs: {
                    label: _vm.$t("AllocationRatioText"),
                    prop: "ratioList." + index + ".ratio",
                    rules: _vm.rules.ratio,
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { type: "number" },
                      model: {
                        value: item.ratio,
                        callback: function ($$v) {
                          _vm.$set(item, "ratio", $$v)
                        },
                        expression: "item.ratio",
                      },
                    },
                    [
                      !item.distributionType
                        ? _c("template", { slot: "append" }, [_vm._v("%")])
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }